import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {
  ClassEntity,
  ClassComponentEntity,
  ClassComponentScheduleEntity,
  TeachingModeEntity,
  TimeZoneEntity,
} from '../types';

// TODO: has runtime warning: Warning: Each child in a list should have a unique "key" prop.

const useStyles = makeStyles({
  classColumn: {
    verticalAlign: 'text-top',
  },
  compColumn: {
    verticalAlign: 'text-top',
  },
});

type ClassSelectedHandler = (selected: ClassEntity) => void;

type TeachingModeDecoder = (code: string) => TeachingModeEntity | undefined;

type TimeZoneDecoder = (code: string) => TimeZoneEntity | undefined;

export interface VseApplFormClassSelectionProps extends Pick<React.HTMLAttributes<HTMLElement>, 'className'> {
  data?: ClassEntity[],
  getTeachingMode: TeachingModeDecoder,
  getTimeZone: TimeZoneDecoder,
  onSelected: ClassSelectedHandler,
}

function renderOtherComponents(
  classes: ReturnType<typeof useStyles>,
  getTeachingMode: TeachingModeDecoder,
  getTimeZone: TimeZoneDecoder,
  comp: ClassComponentEntity,
  schedules?: ClassComponentScheduleEntity[]) {

  const compSchedules = schedules?.filter((s => {
    return s.classID === comp.classID && s.componentID === comp.componentID;
  }));
  const classCompType = comp.componentType;
  const teachingMode = getTeachingMode(comp.teachingMode);

  return (
    <TableRow key={`${comp.classID}-${comp.componentID}`}>
      <TableCell className={classes.compColumn}>{classCompType ? classCompType : undefined}</TableCell>
      <TableCell className={classes.compColumn}>{teachingMode ? teachingMode.description : undefined}</TableCell>
      <TableCell>
        {compSchedules?.map((s: ClassComponentScheduleEntity) => {
          const timeZone = getTimeZone(s.timeZoneCode);
          return (<Box key={`${comp.classID}-${comp.componentID}-${s.scheduleID}`}>{s.description} {timeZone ? `(${timeZone.description})` : undefined}</Box>);
        })}
      </TableCell>
    </TableRow>
  );
}

function renderClass(
  classes: ReturnType<typeof useStyles>,
  getTeachingMode: TeachingModeDecoder,
  getTimeZone: TimeZoneDecoder,
  onClickedHandler: ClassSelectedHandler,
  aClass: ClassEntity,
  checked: boolean) {
  const [firstComp, ...otherComps] = aClass.classComponents ? aClass.classComponents : [];
  const firstCompSchedules = aClass.classComponentSchedules?.filter((s => {
    return s.classID === firstComp.classID && s.componentID === firstComp.componentID;
  }));
  const classCompType = firstComp ? firstComp.componentType : undefined;
  const teachingMode = firstComp ? getTeachingMode(firstComp.teachingMode) : undefined;
  return (
    <TableBody key={`${aClass.classID}`}>
      <TableRow key={`${firstComp.classID}-${firstComp.componentID}`}>
        <TableCell className={classes.classColumn} component="th" scope="row" padding="checkbox" rowSpan={aClass.classComponents?.length}>
          <Checkbox checked={checked} onClick={() => {
            onClickedHandler(aClass);
          }} />
        </TableCell>
        <TableCell className={classes.classColumn} rowSpan={aClass.classComponents?.length}>{aClass.className}</TableCell>
        <TableCell className={classes.classColumn}>{classCompType}</TableCell>
        <TableCell className={classes.classColumn}>{teachingMode ? teachingMode.description : undefined}</TableCell>
        <TableCell>
          {firstCompSchedules?.map((s: ClassComponentScheduleEntity) => {
            const timeZone = getTimeZone(s.timeZoneCode);
            return (<Box key={`${s.classID}-${s.componentID}-${s.scheduleID}`}>{s.description} {timeZone ? `(${timeZone.description})` : undefined}</Box>);
          })}
        </TableCell>
      </TableRow>
      {otherComps.map((comp) => (
        renderOtherComponents(classes, getTeachingMode, getTimeZone, comp, aClass.classComponentSchedules)
      ))}
    </TableBody>
  );
}

export function VseApplFormClassSelection(props: VseApplFormClassSelectionProps) {
  const classes = useStyles();
  const [selected, setSelected] = React.useState<ClassEntity>();

  const handler: ClassSelectedHandler = (c) => {
    setSelected(c);
    props.onSelected(c);
  }
  return (
    <div className={props.className}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Select</TableCell>
            <TableCell>Class</TableCell>
            <TableCell>Component</TableCell>
            <TableCell>Mode of Teaching</TableCell>
            <TableCell>Schedule</TableCell>
          </TableRow>
        </TableHead>
        {props.data?.map((aClass) => {
          const checked = (aClass.classID === selected?.classID);
          return renderClass(classes, props.getTeachingMode, props.getTimeZone, handler, aClass, checked);
        })}
      </Table>
    </div>
  );
}
